import { BuiltinMemberValue } from './BuiltinMemberValue';
export class BuiltinConstantBufferMemberValue extends BuiltinMemberValue {
    constructor(value) {
        super();
        this.value = value;
    }
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitPushBuffer(node, this.value);
            sb.emitHelper(node, options, sb.helpers.wrapBuffer);
        }
    }
}

//# sourceMappingURL=BuiltinConstantBufferMemberValue.js.map
